var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import { Grid } from '@mui/material';
import { ViewTextField } from './ViewTextField';
import { ShowContent } from '../../../components/ShowContent';
export var GridView = function (_a) {
    var _b = _a.index, index = _b === void 0 ? 0 : _b, option = _a.option;
    var render = useCallback(function (fullWidth) {
        return (fullWidth ? 12 : 6);
    }, []);
    var isEmptyBlck = useMemo(function () {
        return (option === null || option === void 0 ? void 0 : option.type) === 'emptyBlock';
    }, [option === null || option === void 0 ? void 0 : option.type]);
    var radioGrid = useMemo(function () { return ({
        display: 'grid',
        justifyContent: 'left'
    }); }, []);
    var textEditorGrid = useMemo(function () { return ({
        display: 'flex',
        width: '100%'
    }); }, []);
    var gridStyle = useCallback(function (type) {
        switch (type) {
            case 'radio':
            case 'check':
                return radioGrid;
            case 'text-editor':
                return textEditorGrid;
            default:
                return {};
        }
    }, [radioGrid, textEditorGrid]);
    return (_jsxs(_Fragment, { children: [_jsx(ShowContent, __assign({ show: !isEmptyBlck }, { children: _jsx(Grid, __assign({ item: true, style: gridStyle(option === null || option === void 0 ? void 0 : option.type), xs: 12, xl: render(option === null || option === void 0 ? void 0 : option.fullWidth), lg: render(option === null || option === void 0 ? void 0 : option.fullWidth), md: render(option === null || option === void 0 ? void 0 : option.fullWidth) }, { children: _jsx(ViewTextField, { label: option === null || option === void 0 ? void 0 : option.label, value: option === null || option === void 0 ? void 0 : option.value, type: option === null || option === void 0 ? void 0 : option.type }) }), "field_".concat(index === null || index === void 0 ? void 0 : index.toString())) })), _jsx(ShowContent, __assign({ show: isEmptyBlck }, { children: _jsx(Grid, { item: true, xs: 12, md: render(option === null || option === void 0 ? void 0 : option.fullWidth), sx: { display: { xs: 'none', md: 'block' } } }, "field_".concat(index === null || index === void 0 ? void 0 : index.toString())) }))] }));
};
